export default __webpack_public_path__ + "static/media/key_800.6eac665a.gif";